import posthog from "posthog-js";
import { posthogApiKey } from "@/config/posthog";

/** Guarded capture — no-ops when PostHog is not initialised. */
function capture(event: string, properties?: Record<string, unknown>) {
  if (!posthogApiKey) return;
  posthog.capture(event, properties);
}

export function trackChatOpened(chatId: string) {
  capture("chat_opened", { chatId });
}

export function trackAttachmentUploaded(fileType: string) {
  capture("attachment_uploaded", { fileType });
}

export function trackFeedbackGiven(messageId: string, rating: string) {
  capture("feedback_given", { messageId, rating });
}

export function trackExportDownloaded(format: string) {
  capture("export_downloaded", { format });
}

export function trackLoginSuccess() {
  capture("login_success");
}

export function trackLoginFailure(reason: string) {
  capture("login_failure", { reason });
}

export function trackSearchPerformed(section: string, queryLength: number) {
  capture("search_performed", { section, queryLength });
}

export function trackFilterApplied(section: string, filterName: string) {
  capture("filter_applied", { section, filterName });
}

export function trackReportDownloaded(reportType: string) {
  capture("report_downloaded", { reportType });
}

export function trackErrorShown(errorType: string, errorMessage: string) {
  capture("error_shown_to_user", { errorType, errorMessage });
}
